const getContentShow = (): [string] => {
  const toursStarted = localStorage.getItem('HJAppcuesContentShown');
  return toursStarted ? JSON.parse(toursStarted) : [];
};

/**
 * @deprecated Please import this function from `@hotjar/tracking` under the `appcues` namespace.
 */
export const showContent = (contentId: string, showOnce = false): void => {
  const toursStarted = getContentShow();

  if (showOnce && toursStarted.includes(contentId)) {
    return;
  }

  if (window.Appcues) {
    window.Appcues.show(contentId);
    if (showOnce) {
      toursStarted.push(contentId);
      localStorage.setItem('HJAppcuesContentShown', JSON.stringify(toursStarted));
    }
  }
};
